'use client';

import { cn } from '@/lib/utils';
import { useSidebar } from '@/providers/SidebarProvider';
import { navigationConfig } from '@/config/navigation';
import { SidebarNav } from './sidebar-nav';
import { SidebarToggle } from './sidebar-toggle';

interface SidebarProps {
  className?: string;
}

export function Sidebar({ className }: SidebarProps) {
  const { isOpen } = useSidebar();

  return (
    <aside
      className={cn(
        'border-sidebar-border bg-sidebar h-full shrink-0 border-r',
        'flex flex-col',
        'transition-all duration-300 ease-in-out',
        isOpen ? 'w-48' : 'w-14',
        'hidden md:flex',
        className
      )}
      aria-label="Main navigation"
    >
      {/* Sidebar header */}
      <div className="border-border flex h-12 items-center justify-between border-b px-3">
        {!isOpen ? null : <span className="text-foreground text-base font-semibold">e6data</span>}
        <SidebarToggle />
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto px-2 pb-2 pt-3">
        <SidebarNav config={navigationConfig} collapsed={!isOpen} />
      </nav>
    </aside>
  );
}
